export const SERIES_MOVIE = 1;
export const MOVIES = 2;
export const SHOW_TV = 3;
export const SPORTS = 4;
export const ETC = 5;


// WEBPACK FOOTER //
// ./src/constants/TypesMedia.js